module.exports = __webpack_public_path__ + "84b5227f68c9b12207cb00731032f4db.png";